import autoAnimate from "@formkit/auto-animate";
import React, { useEffect, useRef } from "react";
// import { Helmet } from "react-helmet-async";

const Header = () => {
  const parent = useRef(null);

  useEffect(() => {
    parent.current && autoAnimate(parent.current, {
      duration: 1000,
      easing: 'ease-out',
    });
  }, []);

  return (
    <>
      {/* <Helmet>
        <title>Best IT Solutions for your business || Racila Softech Pvt Ltd</title>
        <meta name="description" content="Racilaworld delivers the best innovative IT solutions and professional training to help individuals and businesses succeed in the tech industry."/>
        <meta name="keywords" content="Affordable web development services, Best IT solutions company, Cheap website development services , Top web development company in India, Reliable web developers near me, Best tech solutions for startups, Affordable digital transformation services" />
        <meta name="author" content="Racila Softech Pvt Ltd" />
        <meta property="og:title" content="Best IT Solutions for your business || Racila Softech Pvt Ltd" />
        <meta property="og:description" content="Racilaworld delivers the best innovative IT solutions and professional training to help individuals and businesses succeed in the tech industry." />
        <meta property="og:url" content="https://racilaworld.com/" />
        <meta property="og:type" content="website" />
      </Helmet> */}

      <header id="page-top" className="relative flex items-center justify-center min-h-screen pt-12 text-white bg-gray-900 ">
        
         <div
    className="absolute top-0 left-0 w-full h-full z-[1]"
    style={{
      backgroundImage: `
        repeating-linear-gradient(45deg, rgba(0,0,0,0.02) 0, rgba(0,0,0,0.02) 1px, transparent 1px, transparent 10px),
        repeating-linear-gradient(-45deg, rgba(0,0,0,0.02) 0, rgba(0,0,0,0.02) 1px, transparent 1px, transparent 10px)
      `
    }}
  ></div>
        {/* Background Overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: `url(${require('../images/header-bg1.webp')})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-black via-blue-900 to-purple-900 opacity-75"></div>
        </div>

        {/* Content Section */}
        <div ref={parent} className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl font-bold tracking-wide leading-tight opacity-0 translate-y-5 animate-slideIn">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-red-500">
              All IT Services 
            </span>{" "}
            In One Click
          </h1>

          {/* Subheading */}
          <p className="mt-6 text-lg sm:text-xl opacity-0 translate-y-5 animate-fadeIn">
            Empowering businesses with cutting-edge IT solutions in <span className="font-bold text-yellow-400">Web Development, IT Training, IT Consultancy, and Digital Marketing.</span>
            <br />
            We help you innovate, grow, and lead in the digital era.
          </p>

          {/* Call to Action Buttons */}
          <div className="mt-8 flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <a
              href="#about"
              className="px-6 py-3 text-lg font-semibold rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg hover:bg-blue-400 transition-all transform hover:scale-105"
            >
              Learn More
            </a>
          </div>
          {/* Refund Guarantee Badge */}
{/* Guarantee Badge - Stylish */}
<div className="mt-10 flex justify-center">
  <div className="relative bg-white/10 dark:bg-white/5 border border-white/20 backdrop-blur-md text-white px-6 py-5 rounded-2xl shadow-xl max-w-lg w-full text-center">
    <div className="flex items-center justify-center gap-2 mb-2">
      <svg className="w-6 h-6 text-green-400" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
      </svg>
     <h3 className="relative text-lg font-semibold">
      100% Satisfaction Guarantee or 100%
  <span className="relative">
     
    <sup className="absolute left-full text-[14px] mt-2">* </sup>
  </span>   <span className="ml-1">Money Back</span>
  
</h3>

    </div>
    <p className="text-sm text-gray-200">
      We believe in quality. If you’re not happy with our service, we’ll give you a Till full refund.
    </p>
  </div>
</div>


        </div>
        {/* <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-10">
  <svg
    viewBox="0 0 500 150"
    preserveAspectRatio="none"
    className="w-full h-40"
  >
    <path
      d="M0.00,49.98 C150.00,150.00 350.00,-50.00 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
      style={{ stroke: "none", fill: '#ffffff' }} // Match Services background
    />
  </svg>
  </div> */}
  
      </header>
    </>
  );
};

export default Header;
